import Vue from "vue";
import Axios from "axios";

import DataWebConfig from "@Scripts/Config/DataWebConfig";
import AppConfig from "@Scripts/Config/AppConfig";
import { router } from "@Scripts/Config/RouteConfig";
import { store } from "@Scripts/Config/StoreConfig";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

export default class BasePage {
    public static async init() {
        await Localizer.init({
            defaultCulture: (<any>window).App.culture,
            resourceContexts: ["App", "Account"]
        });

        this.initRequestVerificationToken();

        let DataWeb = (<any>window).DataWeb;
        if (DataWeb) {
            Vue.use(DataWeb.default);
            Vue.use(DataWebConfig);

            await DataWeb.Localizer.init({ defaultCulture: (<any>window).App.userCulture, resourceContexts: ["DataWeb", "Account"] });
        }

        AppConfig.AddComponents();
        AppConfig.AddDirectives();

        let vm = new Vue({
            el: "#app",
            router,
            store,
            created() {
                if (DataWeb) {
                    DataWeb.default.registerRoutes(router);
                    DataWeb.default.registerStoreModules(store);
                }
            }
        });

        (<any>window).App.instances.vm = vm;

        this.resetCssAnimations();
        this.setAnalytics();
        this.setHeader();
        this.setSearch();
        this.setResponsive();
        this.setShareButton();
    }

    private static initRequestVerificationToken() {
        var antiforgerytoken = (<any>document.getElementsByName("__RequestVerificationToken")[0]).value;
        if (antiforgerytoken) {
            Axios.defaults.headers.common["RequestVerificationToken"] = antiforgerytoken;
        }
    }

    private static resetCssAnimations() {
        // Styles animations reset
        (<any>window).addEventListener("load", function () {
            let loaders = document.getElementsByClassName("loader-box");
            for (let i = 0; i < loaders.length; i++) {
                loaders[i].classList.add("hide");
            }

            let preLoaders = document.querySelectorAll("[data-preload]");
            for (let i = 0; i < preLoaders.length; i++) {
                preLoaders[i].removeAttribute("data-preload");
            }
        });
    }

    private static setAnalytics() {
        let gaEventItems = document.querySelectorAll("[data-gaevent=\"true\"]");
        if (gaEventItems && gaEventItems.length != 0) {
            for (let i = 0; i < gaEventItems.length; i++) {
                gaEventItems[i].addEventListener("click", function () {
                    switch (gaEventItems[i].getAttribute("data-gatype")) {
                        case "EssayRequest":
                            GTagHelper.sendEvent("click", "open_essay_request");
                            break;
                        case "BookPreview":
                            GTagHelper.sendEvent("click", "book_preview");
                            break;
                        case "Highlight":
                            GTagHelper.sendEvent("click", this.getAttribute("data-gacategory"), this.getAttribute("href"));
                            break;
                        case "YouTubeChannel":
                            GTagHelper.sendEvent("click", "youtube_channel");
                            break;
                    }
                });
            }
        }

        let gaEventEditorItems = document.querySelectorAll(".editor a");
        if (gaEventEditorItems && gaEventEditorItems.length != 0) {
            for (let i = 0; i < gaEventEditorItems.length; i++) {
                gaEventEditorItems[i].addEventListener("click", function () {
                    GTagHelper.sendEvent("click", "link", gaEventEditorItems[i].getAttribute("href"));
                });
            }
        }

        let gaVisualItems = document.querySelectorAll(".swiper-wrapper > .swiper-slide > a.link");
        for (const item of gaVisualItems) {
            if (item) {
                item.addEventListener("click", function (event) {
                    GTagHelper.sendEvent("click", "visual", this.getAttribute("href"));
                }, false);
            }
        }
    }

    private static setHeader() {
        let header = document.getElementById("MenuBox");

        if (header) {
            if (window.scrollY > 0) {
                header.setAttribute("data-minify", "");
            }

            window.addEventListener("scroll", function () {
                if (window.scrollY > 0) {
                    header.setAttribute("data-minify", "");
                } else {
                    header.removeAttribute("data-minify");
                }
            });
        }
    }

    private static setSearch() {
        let openSearchButtons = document.getElementsByClassName("search-open");
        if (openSearchButtons) {
            for (let i = 0; i < openSearchButtons.length; i++) {
                openSearchButtons[i].addEventListener("click", function () {
                    document.getElementsByTagName("body")[0].classList.add("search");
                });
            }
        }
        let closeSearchButtons = document.getElementsByClassName("search-close");
        if (closeSearchButtons) {
            for (let i = 0; i < closeSearchButtons.length; i++) {
                closeSearchButtons[i].addEventListener("click", function () {
                    document.getElementsByTagName("body")[0].classList.remove("search");
                });
            }
        }
    }

    private static setResponsive() {
        let wrapTap = document.getElementById("WrapTap"),
            openMenuButton = document.getElementById("OpenMenuButton"),
            menuBox = document.getElementById("MenuBox");

        if (openMenuButton) {
            openMenuButton.addEventListener("click", function () {
                menuBox.classList.add("show");
                wrapTap.classList.add("show");
            });
        }

        if (wrapTap) {
            wrapTap.addEventListener("click", function () {
                menuBox.classList.remove("show");
                wrapTap.classList.remove("show");
            });
        }

        let backButtons = document.querySelectorAll("[data-back] .button"),
            menuVoices = document.querySelectorAll("[data-exp]");

        if (backButtons) {
            for (const backButton of backButtons) {
                backButton.addEventListener("click", function () {
                    for (const menuVoice of menuVoices) {
                        menuVoice.classList.remove("show");
                    }
                });
            }
        }

        let openFilter = document.getElementById("OpenFilter"),
            filterBox = document.getElementById("FilterBox"),
            closeFilter = document.getElementById("CloseFilter");

        if (openFilter) {
            openFilter.addEventListener("click", function () {
                filterBox.classList.add("show");
                wrapTap.classList.add("show");
            });

            closeFilter.addEventListener("click", function () {
                filterBox.classList.remove("show");
                wrapTap.classList.remove("show");
            });
        }
    }

    private static setShareButton() {
        let openShare = document.getElementById("OpenShare"),
            shareBox = document.getElementById("ShareBox");

        if (openShare) {
            openShare.addEventListener("click", function () {
                shareBox.classList.toggle("show");
            });
        }
    }
}